const withHistory = function () {

    this.isHistoryApiSupported = function () {
        return !!(window.history && history.pushState);
    };

    /**
     * This fires a 'uiHistoryPopped' event upon an onpopstate event on the window object.
     *
     * To address the issue of invalid onpopstate event fired on page load in Webkit browsers, it requires that the
     * current history state has an attribute of 's' of value true. Setting state.s = true marks a page/state as
     * reachable by clicking browser's back button.
     *
     */
    this.registerPopstateListener = function () {
        var existingPopStateListener = window.onpopstate;
        window.onpopstate = function (e) {
            if (window.history.state && window.history.state.s === true) {
                if (existingPopStateListener) {
                    existingPopStateListener();
                }
                this.trigger('uiHistoryPopped');
            }
        }.bind(this);
    };

    this.initializeHistory = function () {
        if (this.isHistoryApiSupported()) {
            this.registerPopstateListener();

            /*
             On initial page load, i.e. user click back button from a different page or user load page using
             browser address bar, the current state is set to null to mark that this page is not affected by
             any onpopstate the browser may or may not fire upon page load.
             */
            window.history.replaceState(null, window.document.title, window.location.href);
        }
    };

    this.pushHistory = function (url) {
        if (this.isHistoryApiSupported()) {

            /*
             Before navigating to a different state, we mark the current state/page reachable by back button
             by assigning state.s == true
             */
            if (!history.state || !history.state.s) {
                window.history.replaceState({s: true}, window.document.title, window.location.href);
            }

            window.history.pushState({s: true}, window.document.title, url);
        }
    };
};

export default withHistory;



// WEBPACK FOOTER //
// ./src/web/js/app/mixins/with-history.js